// src/components/PrivacyBanner.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./PrivacyBanner.css";

const PrivacyBanner = () => {
  return (
    <section className="privacy-banner">
      <Container>
        <Row className="align-items-center">
          <Col md={12} className="text-content">
            <h2 className="banner-title">Privacy Policy</h2>
            <p className="breadcrumb">
              Home <span> » </span> <span className="active">Privacy Policy</span>
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default PrivacyBanner;
